module.exports = __webpack_public_path__ + "static/media/selectLeftArrow.71fdc467.svg";